//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[["ontObject"],"PrintOntObject",{},1,0],[["ontObject"],"PrintToolpathMove",{},1,0],[["ontObject"],"PrintToolpathQuality",{},1,0],[["ontObject"],"PrintExpandedToolpathMove",{},1,0],[["ontObject"],"PrintCutRegions",{},1,0],[["ontObject"],"PrintTurningIpw",{},1,0],[["ontObject"],"PrintSaved3dIpw",{},1,0],[["ontObject"],"PrintOnt3dIpw",{},1,0],[[],"PrintCheckParamIndices",{},0,0],[["ontObject"],"PrintPredictObjectCheckResult",{},1,0],[["ontObject"],"PrintTurnToolPath",{},1,0],[["ontObject"],"PrintTransitionPathBetweenOperations",{},1,0],[[],"PrintPredictJsonCheckResult",{},0,0],[[],"PrintGougeGeometryDataCacheResult",{},0,0],[["tool"],"PrintAreaOfHolderOutlineOfAssemblyTurningTool",{},1,0],[["tool"],"OperationStatus",{},1,0],[["ontObject","paramIndex"],"PrintParamIndex",{},2,0]],[]];
SPLM.CAMAutotestPrint = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CAMAutotestPrint";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;